import { TrackByFunction } from '@angular/core';

export const trackByProperty =
  <T>(property: keyof T): TrackByFunction<T> =>
  (_: number, item: T) =>
    item[property];

export const trackByKey = <T extends { key: string }>() =>
  trackByProperty<T>('key');
